import Router from 'vue-router'
import store from '@/store'
import Signin from '@/components/account/Signin'
import Vue from 'vue'
import { appRoutes } from './module.router.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/acessar',
      name: 'Signin',
      component: Signin,
      meta: { allowAnonymousAccess: true }
    },
    {
      path: '/business',
      name: 'business',
      beforeEnter (to) {
        if (to.params.whiteLabelSubdomain != null) {
          var url = `${process.env.APPLICATION_URL}`.replace('gestao', to.params.whiteLabelSubdomain);
          window.open(`${url}/acesso-remoto?token=${to.params.token}`, '_blank')
        } else {
          window.open(`${process.env.APPLICATION_URL}/acesso-remoto?token=${to.params.token}`,
            '_blank'
          )
        }
      }
    },
    appRoutes
  ]
})

router.beforeResolve((to, from, next) => {
  store.dispatch('account/Initialize').then(() => {
    const auth = store.getters['account/isAuthenticated']
    if (!auth) {
      if (to.matched.some(record => record.meta.allowAnonymousAccess)) {
        next()
      } else {
        next({ path: '/acessar' })
      }
    } else if (to.path === '/acessar') {
      next({ path: '/' })
    } else {
      next()
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js